export const radioResources = {

    "listen-live": {
        name: "Listen Live",
        type: "iframe",
        content: (
            <iframe
                className="radio-live-iframe"
                title="Listen Live"
                width="450" height="316"
                frameBorder="0"
                src="https://live365.com/embeds/v1/player/a96984?s=md&m=dark&c=mp3" />
        ),
        link: "/radio/listen-live",
    },

    "last-played": {
        name: "Last Played Songs",
        type: "iframe",
        content: (
            <iframe
                className="radio-last-iframe"
                title="Last Played Songs"
                width="450" height="511"
                frameBorder="0"
                src="https://live365.com/embeds/v1/played/a96984?s=md&m=dark" />
        ),
        link: "/radio/last-played",
    },

};